import { NgModule } from '@angular/core';

// Required for local builds
import './observable.extensions';

@NgModule()
export class PrototypeExtensionsModule {
  constructor() {
    // Required for remote builds
    require('./observable.extensions');
  }
}
